import { InputProps } from "antd/lib/input";
import { SelectProps } from "antd/lib/select";
import { AutoCompleteProps } from "antd/lib/auto-complete";
import BaseProps from "../BaseProps/baseProps";
import { FormProps } from "antd/lib/form";
const ConfigComponent = {
  input: {
    inCol: true,
    inForm: true,
    col: { xs: 24, sm: 12 }
  } ,
  select: {
    inCol: true,
    inForm: true,
    col: { xs: 24, sm: 12 }
  },
  autoComplete: {
    inCol: true,
    inForm: true,
    col: { xs: 24, sm: 12 }
  } ,
  form: {
    layout: "vertical",
    scrollToFirstError: true
  } ,
  upload: {
    inCol: true,
    inForm: true
  }
};

export default ConfigComponent;
